module.exports = __webpack_public_path__ + "static/media/Sigilyph_gaussian2.0023fde9.png";